export const shouldShowMemberEventActions = (
  isRestrictedUser: boolean,
  canManagePermissions: boolean,
  canDelete: boolean,
): boolean => isRestrictedUser || canManagePermissions || canDelete;
